export default 'M5.33 6.67v-2a2.67 2.67 0 0 1 5.34 0v2zm7.34 0v-2a4.67 4.67 0 0 0-9.34 0v2a5.83 5.83 0 1 0 9.33 0';